export const UrlOptionList = [
  { id: "source", name: "source" },
  { id: "youtube", name: "youtube" },
  { id: "jamendo", name: "jamendo" },
  { id: "insta", name: "insta" },
  { id: "score", name: "score" },
  { id: "imslp", name: "imslp" },
  { id: "etc", name: "etc" }
];
